import React from "react";
// import "./createOrderModal.css";
import { Col, Drawer, Typography } from "antd";
import { MainModal } from "../../../../../../components/Modal/MainModal/MainModal";
import { ModalFooter } from "../../../../../../components/Modal/MainModal/ModalFooter";
// import { dateFormat } from "../../../../../../commonFuntions/CommonUtilFunctions";
import cancelmodalicon from "../../../../../../assets/seller/icons/cancelmodal.svg";
import "./SellerOrderModal.css";

const { Text } = Typography;

export const SellerRejectOrderModal = (props) => {
  const {
    title,
    open,
    handleCloseModal,
    handleCancel,
    handleSave,
    cancelText,
    saveText,
  } = props;
  const getIsMobileView = () =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false;
  const [isMobileView, setIsMobileView] = React.useState(getIsMobileView);

  React.useEffect(() => {
    const handleResize = () => setIsMobileView(getIsMobileView());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const footerContent = (
    <ModalFooter
      cancelText={cancelText}
      saveText={saveText}
      handleCancel={handleCancel}
      handleSave={handleSave}
      saveButtonCss={"cancel-order-button btn-danger"}
    />
  );

  const footer = [footerContent];

  const modalBody = (
    <Col style={{ height: "250px" }} className="create-modal-container text-center">
      <img width={100} height={100} src={cancelmodalicon} style={{}} alt="" />
      <Col className="create-modal-sub-container">
        <Text className="create-modal-recommed-text">
          Are you sure you want to reject the order?
        </Text>{" "}
        <br />
        <Text className="create-modal-recommed-text-2">
          {" "}
          Mad over buildings will attempt to reassign the order to another
          vendor. If you are not sure the please call mob at{" "}
          <a href={`tel:+91 8660423608`}>+91 8660423608</a>
        </Text>
      </Col>
    </Col>
  );

  return (
    <>
      {isMobileView ? (
        <Drawer
          className="seller-reject-mobile-drawer"
          wrapClassName="seller-reject-mobile-drawer-wrap"
          placement="bottom"
          height="56vh"
          title={title}
          open={open}
          onClose={handleCloseModal}
          bodyStyle={{ padding: 0 }}
          contentWrapperStyle={{
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            overflow: "hidden",
          }}
        >
          <div className="seller-reject-drawer-body">
            <div className="seller-reject-drawer-scroll">{modalBody}</div>
            <div className="seller-reject-drawer-footer">{footerContent}</div>
          </div>
        </Drawer>
      ) : (
        <MainModal
          title={title}
          open={open}
          handleCloseModal={handleCloseModal}
          footer={footer}
        >
          {modalBody}
        </MainModal>
      )}
    </>
  );
};
